// @flow
import styled from 'styled-components';

export const Container = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 3em;
    padding: 0 1em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/messages-bar/styles.js